<div>
  <mat-form-field appearance="outline" class="full-width cursor" (click)="open()">
    <mat-label>
      {{ formLabel }}
      <span *ngIf="required">*</span>
    </mat-label>
    <div class="d-flex gap20">
      <input matInput readonly [value]="selectedOption?.name" #trigger
        class="mat-mdc-select-value mat-mdc-select-value-text mat-mdc-select" />
      <div class="mat-mdc-select-arrow-wrapper">
        <span class="mat-mdc-select-arrow">
          <svg viewBox="0 0 24 24" width="24px" height="24px" focusable="false" aria-hidden="true"
            class="ng-tns-c1771602899-16">
            <path d="M7 10l5 5 5-5z" class="ng-tns-c1771602899-16"></path>
          </svg>
        </span>
      </div>
    </div>
    
    <ng-container *ngIf="validators && formSubmit">
      <ng-container *ngFor="let error of validators | keyvalue;">
        <mat-error *ngIf="error?.value">
          <em class="fas fa-exclamation-circle mr-2"></em>
          {{ generalService?.getErrorMessage(formLabel, error?.key) }}
        </mat-error>
      </ng-container>
    </ng-container>
    </mat-form-field>

  <ng-template #dropdownTemplate>
    <div class="dropdown-panel">
      <div *ngIf="isLoader" class="w-100 padt-5">
        <mat-progress-bar [mode]="'indeterminate'">
        </mat-progress-bar>
      </div>
        <div class="dropdown-search-wrapper">
          <mat-form-field appearance="fill" class="search-field" *ngIf="!isLoader">
            <input matInput placeholder="Search..." [formControl]="searchControl" #searchInput />
          </mat-form-field>
        </div>

        <div class="d-flex gap-10 dropdown-item" *ngIf="!showOptions && addOption && !isLoader && service.rbacManagement('case_Casedrilldownedit_AddProtus_AddOption')" (click)="showOptions = !showOptions">
            <mat-icon>add</mat-icon>
            <span> Add new option </span>
        </div>
  
        <div class="add-new-option d-flex gap-10 align-items-center mb-2" *ngIf="showOptions && !isLoader">
          <mat-form-field class="add-field" appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput [formControl]="optionLabel" (input)="nameValidation($event)"/>
          </mat-form-field>
          <mat-form-field class="add-field" appearance="outline">
            <mat-label>Value</mat-label>
            <input matInput [formControl]="optionValue" (input)="valueValidation($event)"/>
          </mat-form-field>
          <img (click)="addNewOption();" src="../../../../assets/images/submit-icon.svg" class="img-fluid submit-icon" title="Submit" alt="Submit"
            [ngClass]="{'submit-disabled' : !optionLabel?.value || !optionValue?.value || optionValue?.errors?.['duplicateError'] || optionLabel?.errors?.['duplicateError']}">
        </div>

        <span class="add-new-option mb-4" *ngIf="optionValue?.errors?.['duplicateError']">
          <mat-error>
            <em class="fas fa-exclamation-circle mr-2"></em>Duplicate value found!
          </mat-error>
        </span>
        <span class="add-new-option mb-4" *ngIf="optionLabel?.errors?.['duplicateError']">
          <mat-error>
            <em class="fas fa-exclamation-circle mr-2"></em>Duplicate name found!
          </mat-error>
        </span>
        <cdk-virtual-scroll-viewport itemSize="48" class="viewport" *ngIf="!isLoader">
          <div *cdkVirtualFor="let option of filteredOptions" class="dropdown-item-wrapper">
            <div class="dropdown-item d-flex justify-space-between align-center"
                 [ngClass]="{ 'selected-value': option?.value === selectedOption?.value }"
                 (click)="select(option)">
              <span>{{ option.name }}</span>
              <img class="delete-btn h-30" (click)="deleteOption(option); $event.stopPropagation()" src="../../../../assets/images/delete.svg" title="Delete" alt="Delete"
                *ngIf="addOption && service.rbacManagement('case_Casedrilldownedit_AddProtus_DeleteOption')" [ngClass]="{ 'filter-delete-icon': option?.value === selectedOption?.value }">
            </div>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
  </ng-template>
</div>